var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import CancelIcon from "../Icons/Cancel";
export var TagSize;
(function (TagSize) {
    TagSize["Small"] = "small";
    TagSize["Medium"] = "medium";
    TagSize["Large"] = "large";
})(TagSize || (TagSize = {}));
const Tag = (_a) => {
    var { checked, children, className, deleteLabel, onDeleteClick, size = TagSize.Medium } = _a, other = __rest(_a, ["checked", "children", "className", "deleteLabel", "onDeleteClick", "size"]);
    return (React.createElement("span", Object.assign({ className: classNames("gerudo-tag", size, className) }, other),
        React.createElement("label", { className: classNames({
                deletable: Boolean(onDeleteClick),
                checked,
            }) },
            typeof children === "string" ? React.createElement("span", null, children) : children,
            onDeleteClick && (React.createElement("button", { onClick: onDeleteClick, "aria-label": deleteLabel || "delete" },
                React.createElement(CancelIcon, null))))));
};
export default Tag;
export { Tag };
//# sourceMappingURL=Tag.js.map